import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Modal, ModalFooter } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import { CheckoutForm } from '../../components/Forms/CheckoutForm.js';
import { FormFieldsWithCart } from '../../components/FormFieldsWithCart/FormFieldsWithCart.js';
import { useIsFormSlotAvailable } from '../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../state.js';
import { updateShippingDetails } from '../../StepShipping/actions.js';
import { getInvoiceFormData, getShippingData } from '../../StepShipping/selectors.js';

const EditableInvoiceSummary = ({ labels  })=>{
    var ref, ref1, ref2;
    const isInvoiceFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Invoice);
    const [invoiceFormData, setInvoiceFormData] = React.useState();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const dispatch = useDispatch();
    const invoiceDetailsInitialData = useSelector(getInvoiceFormData);
    const invoiceShippingData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.invoice;
    const companyShippingData = (ref1 = useSelector(getShippingData)) === null || ref1 === void 0 ? void 0 : ref1.company;
    // companyShippingData also includes invoice summary data(`secondaryEmail` and `recipientCode`) that needs to be mapped
    const invoiceData = swcHelpers.objectSpread({}, invoiceShippingData, {
        secondaryEmail: (invoiceShippingData === null || invoiceShippingData === void 0 ? void 0 : invoiceShippingData.secondaryEmail) || (companyShippingData === null || companyShippingData === void 0 ? void 0 : companyShippingData.secondaryEmail) || '',
        recipientCode: (invoiceShippingData === null || invoiceShippingData === void 0 ? void 0 : invoiceShippingData.recipientCode) || (companyShippingData === null || companyShippingData === void 0 ? void 0 : companyShippingData.recipientCode) || ''
    });
    const hasData = invoiceData && !Object.values(invoiceData).every((x)=>x === null || x === ''
    );
    const InvoiceSummarySlot = Slots.invoice;
    if (!InvoiceSummarySlot && hasData) {
        console.error('This opco is misconfigured. It has invoice data, but no invoice summary card setup.');
    }
    if (!InvoiceSummarySlot || !hasData) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isInvoiceFormAvailable && /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        footer: /*#__PURE__*/ React.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref2 = labels.editModal) === null || ref2 === void 0 ? void 0 : ref2.save,
            onCta: ()=>{
                if (!(invoiceFormData === null || invoiceFormData === void 0 ? void 0 : invoiceFormData.formValid)) {
                    Util.focusToTopErrorFieldOnScreen();
                } else {
                    invoiceFormData && dispatch(updateShippingDetails({
                        form: invoiceFormData
                    }));
                    setIsModalOpen(false);
                }
            },
            onCancel: ()=>setIsModalOpen(false)
        })
    }, /*#__PURE__*/ React.createElement(CheckoutForm, {
        formName: "invoice",
        "data-t": "invoice",
        initialFormState: invoiceDetailsInitialData,
        onChange: (formData)=>setInvoiceFormData(formData)
    }, /*#__PURE__*/ React.createElement(FormFieldsWithCart, {
        formName: ShippingObjectTypes.Invoice
    }))), hasData && /*#__PURE__*/ React.createElement(InvoiceSummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: invoiceData
    }));
};

export { EditableInvoiceSummary, EditableInvoiceSummary as default };
//# sourceMappingURL=EditableInvoiceSummary.js.map
